// ─────────────────────────────────────────────
// src/utils/formatters.js
// Date, currency, string formatters
// ─────────────────────────────────────────────
import { format, formatDistanceToNow, isValid } from 'date-fns';
import { ONT } from '../config/constants';

// ── Date ──────────────────────────────────────
export const formatDate = (date) => {
  if (!date) return '';
  const d = date?.toDate ? date.toDate() : new Date(date);
  return isValid(d) ? format(d, 'MMM d, yyyy') : '';
};

export const timeAgo = (date) => {
  if (!date) return '';
  const d = date?.toDate ? date.toDate() : new Date(date);
  return isValid(d) ? formatDistanceToNow(d, { addSuffix: true }) : '';
};

// ── ONT Token ─────────────────────────────────
export const formatONT = (amount) => {
  if (amount === null || amount === undefined) return '0 ONT';
  return `${Number(amount).toLocaleString()} ONT`;
};

export const ontToUSDT = (ont) => {
  return `$${(Number(ont) * ONT.USDT_RATE).toFixed(2)} USDT`;
};

// ── Wallet address ────────────────────────────
export const shortAddress = (addr) => {
  if (!addr) return '';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
};

// ── Numbers ───────────────────────────────────
export const formatNumber = (n) => Number(n).toLocaleString();

export const formatPercent = (n) => `${Number(n).toFixed(0)}%`;

// ── Strings ───────────────────────────────────
export const capitalize = (s) =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';

export const truncate = (s, n = 80) =>
  s && s.length > n ? `${s.slice(0, n)}…` : s;

export const initials = (name) =>
  name ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) : '?';

// ── File size ─────────────────────────────────
export const formatFileSize = (bytes) => {
  if (bytes < 1024)       return `${bytes} B`;
  if (bytes < 1024 ** 2)  return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
};
